import BeaconTracker from './beacon';
import AjaxTracker from './ajax';
import DummyTracker from './dummy';
import logger from '../../logger';
import FindologicTracker from './interface';

/**
 * Creates an instance of FINDOLOGIC tracker that fits the configuration. If tracking is disabled, a dummy is
 * returned. Tracking is also suppressed for non-DI services.
 *
 * @param {{}} config Service configuration, which is used to look up whether tracking is enabled.
 * @param {Window} [windowObj] The window object to detect the availability of the Beacon API.
 * @param {boolean} config.directIntegration.enabled Flag indicating whether Direct Integration is in use.
 * @param {boolean} config.trackResultsWithFindologic True in case tracking is desired. If false, a dummy tracker is
 *      always returned.
 * @return {FindologicTracker} The tracker that can be expected to work in the current environment dictated
 *      by the window object.
 */
FindologicTracker.getInstance = function (config, windowObj) {
    if (typeof windowObj === 'undefined') {
        windowObj = window;
    }

    let implementation;

    if (config.directIntegration.enabled && config.trackResultsWithFindologic) {
        logger.info('FINDOLOGIC tracking enabled.');
        if (typeof windowObj.navigator.sendBeacon === 'function') {
            logger.info('FINDOLOGIC tracking will use Beacon for transmission.');
            implementation = new BeaconTracker(config);
        } else {
            logger.info('FINDOLOGIC tracking will use AJAX for transmission due to lack of Beacon API.');
            implementation = new AjaxTracker(config);
        }
    } else {
        logger.info('FINDOLOGIC tracking disabled.');
        implementation = new DummyTracker(config);
    }

    return implementation;
};

export default FindologicTracker;
